<template>
  <section class="py-20 bg-white">
    <div class="container mx-auto px-4">
      <div class="text-center mb-12">
        <div
          class="text-title font-bold text-[#333333] leading-tight mb-6 uppercase"
        >
          Featured Products
        </div>
      </div>

      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
        <div
          v-for="product in products"
          :key="product.id"
          class="bg-white rounded-lg overflow-hidden hover:shadow-xl transition-shadow duration-300"
        >
          <div
            class="aspect-square overflow-hidden relative cursor-pointer"
            @click="onFeaturedProductsClick(product)"
          >
            <img
              :src="product.imageUrl"
              :alt="product.name"
              class="w-[90%] mx-auto object-cover hover:scale-105 transition-transform duration-500"
            />
          </div>
          <p class="text-gray-600 mb-10 cursor-default text-center font-medium">
            {{ product.description }}
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Template',
  components: {},
  data() {
    return {
      products: [
        {
          id: 1,
          name: 'Lapel Pin',
          description: 'Lapel Pin',
          imageUrl: require('@/assets/Lapel Pin 1-1.jpg')
        },
        {
          id: 2,
          name: 'Keychain',
          description: 'Keychain',
          imageUrl: require('@/assets/Keychain 1-2.png')
        },
        {
          id: 3,
          name: 'Challenge Coin',
          description: 'Challenge Coin',
          imageUrl: require('@/assets/Challenge Coin 1-3.jpg')
        },
        {
          id: 4,
          name: 'Medal',
          description: 'Medal',
          imageUrl: require('@/assets/Medal 1-4.jpg')
        },
        {
          id: 5,
          name: 'Bottle Opener',
          description: 'Bottle Opener',
          imageUrl: require('@/assets/Bottle Opener 2-1.jpg')
        },
        {
          id: 6,
          name: 'Fridge Magnet',
          description: 'Fridge Magnet',
          imageUrl: require('@/assets/Fridge Magnet 2-2.jpg')
        },
        {
          id: 7,
          name: 'Belt Buckle',
          description: 'Belt Buckle',
          imageUrl: require('@/assets/Belt Buckle 2-3.jpg')
        },
        {
          id: 8,
          name: 'Ashtray',
          description: 'Ashtray',
          imageUrl: require('@/assets/Ashtray 2-4.jpg')
        }
      ]
    }
  },
  methods: {
    onFeaturedProductsClick(p) {
      this.$bus.$emit('navi-page', '/products')
      this.$router.push({
        path: '/products',
        query: { category: p.name }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/page/index/featuredProductSection.vue